import React, { useEffect, useState } from 'react';
import { getAnalytics, setAnalyticsCollectionEnabled } from 'firebase/analytics';
import { useCookieConsent } from '../cookies/CookieConsentContext';
import { app } from './firebaseConfig';

const runtimeConfig = window.__CONFIG__ || {};

const AnalyticsProvider = ({ children }) => {
  const { consent } = useCookieConsent();
  const [analytics, setAnalytics] = useState(null);

  const environment =
    runtimeConfig.REACT_APP_ENVIRONMENT ||
    process.env.REACT_APP_ENVIRONMENT ||
    'development';

  useEffect(() => {
    if (consent & environment === 'production') {
      try {
        const analyticsInstance = getAnalytics(app);
        setAnalyticsCollectionEnabled(analyticsInstance, true);
        setAnalytics(analyticsInstance);
      } catch (error) {
        console.error("Error initializing analytics:", error);
      }
    } else if (analytics) {
      setAnalyticsCollectionEnabled(analytics, false);
    }
  }, [consent, analytics]);

  return <>{children}</>;
};

export default AnalyticsProvider;
